module.exports = __webpack_public_path__ + "img/1723132583404-cookies.jpg.8f0753cb.webp";